import addEntity from 'owa-controls-findpeople-feedback-manager/lib/actions/addEntity';
import FindControlViewState from 'owa-recipient-types/lib/types/FindControlViewState';
import FindRecipientPersonaType from 'owa-recipient-types/lib/types/FindRecipientPersonaType';
import EntityAddSource from 'owa-service/lib/contract/EntityAddSource';
import { isNullOrWhiteSpace } from 'owa-string-utils';

const PRIVATE_DL_ROUTING_TYPE = 'PDL';

/**
 * Adds a find people entity feedback for a persona picked from the find control
 */
export default function addFindPeopleEntityFromResults(
    recipientWellViewState: FindControlViewState,
    persona: FindRecipientPersonaType,
    itemPosition: number,
    entityAddSource: EntityAddSource
) {
    if (persona) {
        let displayName = getDisplayName(persona);
        let extraData = {
            TargetEntityType: persona.PersonaTypeString,
        };

        if (!isNullOrWhiteSpace(displayName)) {
            let recipientEmailAddressesAndPositionIndexesDictionary: {
                [displayName: string]: number;
            } = {};
            recipientEmailAddressesAndPositionIndexesDictionary[displayName] = itemPosition;

            addEntity(
                recipientWellViewState.findPeopleFeedbackManager,
                entityAddSource,
                recipientWellViewState.queryString,
                displayName,
                persona.TransactionId,
                recipientEmailAddressesAndPositionIndexesDictionary,
                extraData
            );
        }
    }
}

function getDisplayName(persona: FindRecipientPersonaType): string {
    let email = persona.EmailAddress;
    let isPDL = email.RoutingType === PRIVATE_DL_ROUTING_TYPE;

    return isPDL ? email.Name : email.EmailAddress;
}
